<template>
  <div class="stock-apply">
    <!-- tab -->
    <ContentHeader :stock-nav="true" :show-back="false" />

    <div class="content-container">
      <!-- 查询条件 -->
      <div class="query-panel">
        <div class="btn-line btn-line-right">
          <el-button
            class="btn-orange-plain"
            size="small"
            @click="searchStockCart"
            >查看物资申请购物车</el-button
          >
          <el-button
            class="btn-orange-plain"
            size="small"
            @click="goToApplyOrder"
            >查看物资申请订单</el-button
          >
          <el-button
            class="btn-orange-plain"
            @click="handleExport()"
            size="small"
            >可申请明细下载</el-button
          >
        </div>
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input
                  v-model="queryParam.itemName"
                  placeholder="请输入商品名称"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编码">
                <el-input
                  v-model="queryParam.itemCode"
                  placeholder="请输入商品编码"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库">
                <el-select
                  v-model="queryParam.warehouseId"
                  placeholder="请选择所在仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="品牌部门">
                <el-select
                  v-model="queryParam.buType"
                  placeholder="请选择品牌部门"
                  clearable
                >
                  <el-option
                    v-for="option in buTypeList"
                    :key="option.buType"
                    :label="option.buTypeName"
                    :value="option.buType"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品分类">
                <el-select
                  v-model="queryParam.categoryId"
                  placeholder="请选择分类"
                  clearable
                >
                  <el-option
                    v-for="option in categoryList"
                    :key="option.categoryId"
                    :label="option.categoryName"
                    :value="option.categoryId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品品牌">
                <el-select
                  v-model="queryParam.abiBrandId"
                  placeholder="请选择商品品牌"
                  clearable
                >
                  <el-option
                    v-for="option in brandList"
                    :key="option.abiBrandId"
                    :label="option.abiBrandName"
                    :value="option.abiBrandId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>

      <!-- 数据显示 -->
      <div class="table-show" :loading="loading">
        <el-table :data="stockApplyList" class="while-data-table">
          <el-table-column label="图片">
            <template slot-scope="scope">
              <div class="item-image" @click="handleViewPic(scope.row)">
                <img :src="getImageUrl(scope.row)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="商品名称"></el-table-column>
          <el-table-column prop="itemCode" label="商品编码"></el-table-column>
          <el-table-column
            prop="warehouseName"
            label="所在仓库"
          ></el-table-column>
          <el-table-column
            prop="availableAmount"
            label="可用数量"
          ></el-table-column>
          <el-table-column prop="orgCode" label="区域编码"></el-table-column>
          <el-table-column prop="buTypeName" label="品牌部门"></el-table-column>
            <el-table-column prop="specParam" label="箱规" width="60"></el-table-column>
          <el-table-column
            clign="center"
            label="操作"
            width="150"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <i
                  class="iconfont iconzu19 cursor"
                  v-if="scope.row.availableAmount > 0"
                  @click="handleAddCart(scope.row)"
                  title="加入购物车"
                />
                <i
                  class="el-icon-shopping-bag-1 cursor"
                  v-if="scope.row.availableAmount > 0"
                  @click="handleOrderNow(scope.row)"
                  title="立即下单"
                ></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <v-form ref="form" :url="exportUrl" :params="exportParam" />
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { commonUtils } from '@/utils/common'
// import { mapState } from 'vuex'
import vForm from '@/components/v-form'
export default {
  name: 'stock-apply',
  components: {
    ContentHeader,
    vForm
  },
  data () {
    return {
      buTypeList: [],
      loading: false,
      exportParam: {},
      exportUrl: null,
      queryParam: {
        page: 1,
        pageSize: 10,
        itemName: '',
        itemCode: '',
        warehouseId: '',
        buType: '',
        categoryId: '',
        abiBrandId: ''
      },
      categoryList: [],
      brandList: [],
      warehouseList: [],
      stockApplyList: [],
      total: 0
    }
  },
  computed: {
    // ...mapState({
    //   buTypeList: state => state.base.stockBuTypeMap
    // })
  },
  activated () {
    this.getStockApplyList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // this.$store.dispatch('getDictByName', 'stockBuTypeMap')
      this.getWarehouseList()
      this.getCategory()
      this.getBrand()
      this.getStockApplyList()
    },
    // 获取物资申请列表
    getStockApplyList () {
      this.loading = true
      this.$store
        .dispatch('getApplyList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockApplyList = res.data.resultData.stockApplyItemList
            this.total = res.data.resultData.pageInfo.totalCounts
            this.buTypeList = res.data.resultData.clientLinkBuTypeList
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 导出
    handleExport () {
      this.exportUrl = commonUtils.getApiUrl('/stock/apply/item/export')
      this.exportParam = Object.assign({}, this.queryParam)
      delete this.exportParam.page
      delete this.exportParam.pageSize
      this.$confirm('是否根据当前条件导出文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => {})
    },

    // 查看物资申请订单
    goToApplyOrder () {
      this.$router.push({
        path: '/stock/stock-apply-order'
      })
    },
    // 查看购物车
    searchStockCart () {
      this.$router.push({
        path: '/stock/cart',
        query: { moduleTypeName: 'apply' }
      })
    },
    // 加入购物车
    handleAddCart (scope) {
      let params = {
        itemId: scope.itemId,
        moduleType: '03',
        itemQuantity: 1,
        warehouseId: scope.warehouseId,
        orgCode: scope.orgCode,
        buType: scope.buType
      }
      this.loading = true
      this.$store
        .dispatch('addStockCart', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$message.success('商品加入购物车成功')
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('商品加入购物车失败')
        })
    },

    // 立即发货
    handleOrderNow (scope) {
      this.$confirm('是否确认立即下单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$router.push({
            path: '/stock/fill-order',
            query: { type: 'apply', linkId: scope.linkId }
          })
        })
        .catch(() => {})
    },
    // 查询
    searchQuery () {
      this.queryParam.page = 1
      this.getStockApplyList()
    },
    // 重置
    resetQuery () {
      this.queryParam = this.$options.data().queryParam
      this.getStockApplyList()
    },
    handleViewPic (item) {
      window.open(this.getImageUrl(item))
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.itemImageUriList && item.itemImageUriList.length > 0) {
        imageUri = item.itemImageUriList[0]
      }
      return commonUtils.getImageUrl(imageUri)
    },
    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseListAll').then(response => {
        this.warehouseList = response.data.resultData.warehouseList
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getStockApplyList()
    },
    // 商品分类
    getCategory () {
      this.$store.dispatch('getStockCategoryList').then(response => {
        if (response.data.resultCode === '0') {
          this.categoryList = response.data.resultData.stockItemCategoryList
        }
      })
    },
    // 商品品牌
    getBrand () {
      this.$store.dispatch('getStockBrandList').then(response => {
        if (response.data.resultCode === '0') {
          this.brandList = response.data.resultData.brandList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-line {
  padding-top: 0;
}
.btn-line-right {
  text-align: right;
  margin-bottom: 10px;
}
.iconzu19,
.el-icon-shopping-bag-1 {
  font-size: 22px;
  color: $base-plain;
  margin-left: 20px;
}
.item-image {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 95%;
    max-height: 95%;
    border: none;
    cursor: pointer;
  }
}
</style>
